import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgOuderAlleenstaand = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fill="#85BDED"
      d="M20 18a6 6 0 1 0 0-12 6 6 0 0 0 0 12"
    />
    <path
      fill="#85BDED"
      fillRule="evenodd"
      d="M20 18a6 6 0 0 1 6 6v10H14V24a6 6 0 0 1 6-6"
      clipRule="evenodd"
    />
    <path
      fill="#0061CD"
      d="M9.41 26a4 4 0 1 0 0-8 4 4 0 0 0 0 8M30.57 24a4 4 0 1 0 0-8 4 4 0 0 0 0 8"
    />
    <path
      fill="#00215B"
      fillRule="evenodd"
      d="M17.017 12.533a3.02 3.02 0 1 0 6.006 0l.994-.106a4.019 4.019 0 1 1-7.994 0z"
      clipRule="evenodd"
    />
    <path
      fill="#0061CD"
      fillRule="evenodd"
      d="M13.46 30a4 4 0 0 0-8 0v4h8zM34.57 28a4 4 0 1 0-8 0v6h8z"
      clipRule="evenodd"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgOuderAlleenstaand);

export default ForwardRef;
